import { StateCreator } from 'zustand'

const snackbarInitialState = { open: false, message: '' }
const loadingInitialState = false

export interface MainSlice {
  depotCode: string | null
  setDepotCode: (depotCode: string | null) => void
  snackbar: typeof snackbarInitialState
  setSnackbar: (payload: typeof snackbarInitialState) => void
  loading: boolean
  setLoading: (payload: boolean) => void
  tabValue: number
  setTabValue: (payload: number) => void
}

const createMainSlice: StateCreator<MainSlice> = (set) => ({
  depotCode: null,
  setDepotCode: (depotCode) => set({ depotCode }),
  snackbar: snackbarInitialState,
  setSnackbar: (newSnackbar) => {
    set(() => ({ snackbar: newSnackbar }))
  },
  loading: loadingInitialState,
  setLoading: (newLoadingState) => {
    set(() => ({ loading: newLoadingState }))
  },
  tabValue: 0,
  setTabValue: (payload) => {
    set(() => ({ tabValue: payload }))
  },
})

export default createMainSlice
